import React from 'react';
import './GroomBride.css';

// Import assets
import sectionBg from '../assets/backgrounds/section-bg-3.svg';

// Floral ornament SVG component
const FloralOrnament = () => (
    <svg viewBox="0 0 64 64" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
        <path d="M32 4C32 4 28 12 28 20C28 24 30 28 32 28C34 28 36 24 36 20C36 12 32 4 32 4Z"/>
        <path d="M32 60C32 60 28 52 28 44C28 40 30 36 32 36C34 36 36 40 36 44C36 52 32 60 32 60Z"/>
        <path d="M4 32C4 32 12 28 20 28C24 28 28 30 28 32C28 34 24 36 20 36C12 36 4 32 4 32Z"/>
        <path d="M60 32C60 32 52 28 44 28C40 28 36 30 36 32C36 34 40 36 44 36C52 36 60 32 60 32Z"/>
        <path
            d="M10.3 10.3C10.3 10.3 17.7 14.1 22.6 19C25.4 21.8 26.8 25.2 25.4 26.6C24 28 20.6 26.6 17.8 23.8C12.9 18.9 9.1 11.5 9.1 11.5L10.3 10.3Z"/>
        <path
            d="M53.7 53.7C53.7 53.7 46.3 49.9 41.4 45C38.6 42.2 37.2 38.8 38.6 37.4C40 36 43.4 37.4 46.2 40.2C51.1 45.1 54.9 52.5 54.9 52.5L53.7 53.7Z"/>
        <path
            d="M53.7 10.3C53.7 10.3 49.9 17.7 45 22.6C42.2 25.4 38.8 26.8 37.4 25.4C36 24 37.4 20.6 40.2 17.8C45.1 12.9 52.5 9.1 52.5 9.1L53.7 10.3Z"/>
        <path
            d="M10.3 53.7C10.3 53.7 14.1 46.3 19 41.4C21.8 38.6 25.2 37.2 26.6 38.6C28 40 26.6 43.4 23.8 46.2C18.9 51.1 11.5 54.9 11.5 54.9L10.3 53.7Z"/>
        <circle cx="32" cy="32" r="4"/>
    </svg>
);

const GroomBride = ({guestLabel, showRsvp = true}) => {
    return (
        <section className="groom-bride" aria-labelledby="groom-bride-title">
            {/* Optional background texture */}
            <div
                className="groom-bride__bg-texture"
                style={{backgroundImage: `url(${sectionBg})`}}
                aria-hidden="true"
            />

            <div className="section-container groom-bride__content">
                {/* Floral Ornament */}
                <div className="groom-bride__ornament" aria-hidden="true">
                    <FloralOrnament/>
                </div>

                {/* Invitation Text */}
                <div className="groom-bride__invitation">
                    <p className="groom-bride__invitation-text">
                        {guestLabel ? (
                            // Personalized invitation - show only guest label
                            guestLabel
                                .split(/<br\s*\/?>/i)
                                .map((part, i, arr) => (
                                    <React.Fragment key={i}>
                                        {part}
                                        {i < arr.length - 1 ? <br/> : null}
                                    </React.Fragment>
                                ))
                        ) : (
                            // Generic invitation - show full text
                            <>
                                Pozivamo Vas na vjenčanje kojim ćemo okruniti našu ljubav i započeti novo zajedničko
                                poglavlje
                                života.
                                <br/><br/>
                                S radošću bismo željeli da budete uz nas dok jedno drugome izgovaramo sudbonosno „da",
                                okruženi
                                obitelji, prijateljima i iskrenim osmijesima.
                            </>
                        )}
                    </p>
                </div>

                {/* CTA Button - only show on invite page when RSVP is enabled */}
                {guestLabel && showRsvp && (
                    <a
                        href="#rsvp"
                        className="groom-bride__cta"
                        role="button"
                    >
                        Potvrdi dolazak
                    </a>
                )}
            </div>
        </section>
    );
};

export default GroomBride;
